module.exports = __webpack_public_path__ + "img/goyoga-manager-plugin-reservation.d4a2be3.jpeg";